import {
  useUserMenuAvatar,
  useUserMenuProfile,
} from '@monash/portal-frontend-common';
import c from './consent-disclaimer.module.scss';
import { fontStyles, Icon, LoadingIndicator } from '@monash/portal-react';
import classNames from 'classnames';
import { useContext } from 'react';
import { DataContext } from '@/components/providers/data-provider/DataProvider';

const ConsentDisclaimer = () => {
  const { avatar, isLoadingAvatar, profileData, isLoadingProfileData } =
    useContext(DataContext);

  const isLoading = isLoadingAvatar || isLoadingProfileData;

  const { avatarSrc } = useUserMenuAvatar({
    avatarData: avatar,
    getData: false,
  });

  const { name, id, email, pronouns } = useUserMenuProfile({
    profileData,
    getData: false,
  });

  if (isLoading) {
    return (
      <div className={c.loading}>
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className={c.consentContainer}>
      <div className={c.userInfo}>
        <img className={c.avatarContainer} src={avatarSrc} />
        <div className={classNames(fontStyles.heading, fontStyles.md)}>
          {name}
        </div>
        <div className={c.pronouns}>{pronouns}</div>
      </div>
      <div className={c.consentTextContainer}>
        <div className={c.consentTextHeader}>
          <div className={classNames(fontStyles.heading, fontStyles.sm)}>
            Application Consent
          </div>
          <div>Allow Monash to access this info about you</div>
        </div>

        <div className={c.personalField}>
          <Icon.User color="var(--card-text-secondary-color)" />
          <div className={c.label}>Name</div>
          <div className={c.value}>{name}</div>
        </div>

        <div className={c.personalField}>
          <Icon.UserCard color="var(--card-text-secondary-color)" />
          <div className={c.label}>Student ID</div>
          <div className={c.value}>{id}</div>
        </div>

        <div className={c.personalField}>
          <Icon.Mail color="var(--card-text-secondary-color)" />
          <div className={c.label}>Monash Email</div>
          <div className={c.value}>{email}</div>
        </div>

        <div>
          <div>
            Review Monash's{' '}
            <a href="https://www.monash.edu/privacy-monash/privacy-monash">
              Privacy Policy
            </a>
            .
          </div>
          <div>
            By submitting, I consent to the use of my information above for the
            application.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentDisclaimer;
